import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// MUI Components
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import VirtualKeyboard from "../Shared/VirtualKeyboard";
// Actions
import {
  setSampleNote,
  setLocationNote,
  toggleNotesFocus,
  setVirtualKeyboard,
  setStudyNote,
} from "../../actions";
import { customTheme } from "../../constants/customTheme";

const useStyles = makeStyles({
  gridItem: {
    width: "100%",
  },
  locationNotesContainer: {
    display: "flex",
    flex: "1 1 auto",
    minWidth: "300px",
    paddingBottom: 0,
    marginTop: "20px",
  },
  samplesNotesContainer: {
    display: "flex",
    flex: "1 1 auto",
    padding: "20px",
    paddingBottom: 0,
  },
  studyNotesContainer: {
    display: "flex",
    flex: "1 1 auto",
    paddingBottom: 0,
  },
  notesStyle: (props) => ({
    "& .MuiFilledInput-inputMultiline": {
      ...customTheme(props.theme).customScrollBar,
    },
  }),
});

const Notes = (props) => {
  const classes = useStyles(props);
  const {
    locationNotes,
    sampleNotes,
    studyNotes,
    sampleId,
    locationId,
    prompt,
  } = props;

  const [keyboardInput, setKeyboardInput] = React.useState({
    inputName: "note",
    inputUpdate: { note: "" },
  });

  const handleupdateNote = (event) => {
    if (prompt === "SAMPLE") {
      if (event.target) {
        props.setSampleNote(sampleId, event.target.value);
        // Update virtualKeyboard with the manually entered studyInfo
        setKeyboardInput({
          ...keyboardInput,
          inputUpdate: { note: event.target.value },
        });
      } else {
        props.setSampleNote(sampleId, event);
      }
    } else if (prompt === "LOCATION") {
      if (event.target) {
        props.setLocationNote(locationId, event.target.value);
        // Update virtualKeyboard with the manually entered studyInfo
        setKeyboardInput({
          ...keyboardInput,
          inputUpdate: { note: event.target.value },
        });
      } else {
        props.setLocationNote(locationId, event);
      }
    } else if (prompt === "STUDY") {
      if (event.target) {
        props.setStudyNote(event.target.value);
        // Update virtualKeyboard with the manually entered studyInfo
        setKeyboardInput({
          ...keyboardInput,
          inputUpdate: { note: event.target.value },
        });
      } else {
        props.setStudyNote(event);
      }
    }
  };

  return (
    <Grid className={classes.gridItem} item>
      <div
        className={
          prompt === "SAMPLE"
            ? classes.samplesNotesContainer
            : prompt === "STUDY"
            ? classes.studyNotesContainer
            : classes.locationNotesContainer
        }
      >
        <TextField
          label={prompt === "STUDY" ? "Study Notes" : "Notes"}
          multiline={true}
          rows="4"
          value={
            prompt === "SAMPLE"
              ? sampleNotes === null
                ? ""
                : sampleNotes
              : prompt === "STUDY"
              ? studyNotes == null
                ? ""
                : studyNotes
              : locationNotes === null
              ? ""
              : locationNotes
          }
          rowsMax="10" // allows height to expand to this value when notes get long
          onChange={handleupdateNote}
          onFocus={() => {
            props.toggleNotesFocus();
            props.setVirtualKeyboard(true);
          }} //if notes is in focus then the keypress navigation will be disabled
          onBlur={props.toggleNotesFocus}
          fullWidth={true}
          variant="filled"
          className={classes.notesStyle}
        />
      </div>
      {!props.dialogOpen && ( // Dont render notes keyboard because it will interfere with the dialog keyboard
        <VirtualKeyboard
          anchor={"left"}
          keyboardInitialInput={{
            note:
              prompt === "SAMPLE"
                ? sampleNotes
                : prompt === "STUDY"
                ? studyNotes
                : locationNotes,
          }}
          keyboardInputUpdate={keyboardInput.inputUpdate}
          keyboardInputName={keyboardInput.inputName}
          keyboardChange={(e) => handleupdateNote(e)}
        />
      )}
    </Grid>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setSampleNote,
      setLocationNote,
      toggleNotesFocus,
      setVirtualKeyboard,
      setStudyNote,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    sampleId: state.samples.selectedSampleId,
    locationId: state.locations.selectedLocationId,
    theme: state.utility.theme,
    locationNotes:
      state.protocol.locations[state.locations.selectedLocationId].notes,
    sampleNotes:
      state.samples.selectedSampleId &&
      state.samples.selectedSampleId !== "SAMPLE_COLUMN"
        ? state.samples.byId[state.samples.selectedSampleId].notes
        : null,
    studyNotes: state.studyInfo.notes,
    dialogOpen:
      state.utility.dialog.studySaveDialog ||
      state.utility.dialog.saveProtocolDialog ||
      state.utility.dialog.studyLockDialog ||
      state.utility.dialog.exportPdfDialog ||
      state.utility.dialog.exportCsvDialog ||
      state.utility.dialog.quitDialog,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);
